<template>
  <div>
    <form @submit.prevent="save">
      <div class="modal-card">
        <section class="modal-card-body">
          <b-message type="is-info">
            <p class="is-size-5 has-text-weight-bold mb-sm">Remove Approval?</p>
            <p class="is-size-7">
              You can unlock this deliverable for editing by removing the approval.
              Are you sure you want to proceed?
            </p>
          </b-message>
        </section>
        <footer class="modal-card-foot space-between">
          <b-button @click="$parent.close()">Close</b-button>
          <b-button
            type="is-primary"
            native-type="submit"
            :loading="saving"
            :disabled="saving">
            Remove Approval
          </b-button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['api', 'context'])
  },
  data () {
    return {
      period: null,
      saving: false,
      errors: {}
    }
  },
  methods: {
    save () {
      this.saving = true
      const endpoint = this.api.route + '/projects/' + this.project.id + '/deliveries/' + this.delivery.id + '/actions/unapprove'
      this.$http.put(endpoint).then(response => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Delivery updated!' })
        this.$parent.close()
        this.$emit('delivery:saved')
      })
    }
  },
  props: {
    project: {
      type: Object,
      required: true
    },
    delivery: {
      type: Object,
      required: true
    }
  }
}
</script>
